"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceData = getDeviceData;
exports.getDeviceFile = getDeviceFile;
exports.getDevices = getDevices;
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
var _config = _interopRequireDefault(require("../config/config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
/* eslint-disable @typescript-eslint/no-unused-vars */

function getDevices() {
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/consumption/v0/locations"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
  }, 'locations');
}
function getDeviceData(serialNumber, fromDate, toDate) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/consumption/v0/locations/").concat(serialNumber, "/data?from=").concat(fromDate, "&to=").concat(toDate), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getDeviceFile(locationId, fromDate, toDate) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/consumption/v0/locations/").concat(locationId, "/excel?from=").concat(fromDate, "&to=").concat(toDate), {}, _RestHelper.default.setXClientHeader({
    responseType: 'arraybuffer'
  }, _config.default.CHANNEL_CONFIG.portal));
}